import Validation from '../Validation';

/**
 * all functions recieve transfreeDtails/contactDetails, and return corresponding data
 */

/**
 * For all currentState, it follows the original idea which is: 
 * 
   public enum CurrentState
       {
           Unchanged = 0,
           Added = 1,
           Modified = 2,
           Deleted = 3
       }
 * The code is in c#, in this case, the value will just passed by whichever component calling the methods below
 */

//  mask phone #
function phoneNumberMask(number, phoneType) {
    // if it's not all numeric, then it just switched from international to domestic 
    if (Validation.allNumeric(number)) {
        let x;
        if(phoneType === 'NB'){
            x = number.replace(/\D/g, '').match(/(\d{0,2})(\d{0,8})/);
            number = !x[2] ? x[1] : '(' + x[1] + ')' + x[2]
        }
        else if (phoneType !== 'MB') {   // follow (11) 1111 1111 's format
            x = number.replace(/\D/g, '').match(/(\d{0,2})(\d{0,4})(\d{0,4})/);
            number = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? ' ' + x[3] : '');
        } else {    // follow 1111 111 111 's format w/ mobile
            x = number.replace(/\D/g, '').match(/(\d{0,4})(\d{0,3})(\d{0,3})/);
            number = !x[2] ? x[1] : x[1] + ' ' + x[2] + (x[3] ? ' ' + x[3] : '');
        }
    }

    return number;
}

// recover phone#
function unmaskPhoneNumber(number, phoneType, isInternational) {
    if (number) {
        if (!isInternational) {
            return number.replace(/[^0-9]/g, '').substring(0, 10);
        } else return number;
    }
}

/**
 * Generate a single phone object
 * @param {*} phone 
 */
function getSinglePhone(phone, currentState) {
    let singlePhone = {};
    singlePhone.PartyID = phone.PartyID;
    singlePhone.TelephoneNumber = phone.TelephoneNumber;
    singlePhone.AddressID = phone.AddressID;
    singlePhone.PreferredContactMethodTypeID = phone.PreferredContactMethodTypeID;
    singlePhone.AddressSubTypeID = phone.AddressSubTypeID;
    singlePhone.ConcurrencyCheck = phone.ConcurrencyCheck;
    singlePhone.PartyAddressConcurrencyCheck = phone.PartyAddressConcurrencyCheck;
    singlePhone.TelephoneNumberConcurrencyCheck = phone.TelephoneNumberConcurrencyCheck;
    singlePhone.PartyAddressID = phone.PartyAddressID;
    singlePhone.TelephoneNumberAddressID = phone.TelephoneNumberAddressID;
    singlePhone.IsInternational = phone.IsInternational;
    singlePhone.CurrentState = currentState;
    singlePhone.IsPrimaryContact = phone.IsPrimaryContact;
    singlePhone.AddressUsageTypeID = phone.AddressUsageTypeID;
    return singlePhone;
}

/**
 * if the phone # doesn't exist, call this method to create a dummy value
 * @param {integer} partyId, the corresponding party id
 * @param {integer} addressUsageTypeID, determine which type of phone is
 */
function createSinglePhone(partyId, addressUsageTypeID) {
    let singlePhone = {};
    singlePhone.PartyID = partyId;
    singlePhone.TelephoneNumber = '';
    singlePhone.AddressUsageTypeID = addressUsageTypeID;
    singlePhone.AddressSubTypeID = 1;
    singlePhone.CurrentState = 1;
    singlePhone.IsInternational = false;
    singlePhone.IsPrimaryContact = addressUsageTypeID === 17 ? true : false;
    singlePhone.AddressID = 0;
    singlePhone.PreferredContactMethodTypeID = 0;
    singlePhone.PartyAddressConcurrencyCheck = null;
    singlePhone.PartyAddressID = 0;
    singlePhone.TelephoneNumberAddressID = 0;
    singlePhone.TelephoneNumberConcurrencyCheck = null;
    return singlePhone;
}

function getPhoneNumByAddressUsageTypeID(transfreeDetails, addressUsageTypeID) {
    const phoneNums = getPhoneNumbers(transfreeDetails, 0);
    if (addressUsageTypeID === 17) {
        return phoneNums.BHPhone;
    } else if (addressUsageTypeID === 18) {
        return phoneNums.AHPhone;
    } else if (addressUsageTypeID === 19) {
        return phoneNums.MBPhone;
    }
}

/**
 * Get a list of phones and return it in the format: 
 * {
 *   AHPhone: {}
 *   BHPhone: {}
 *   MBPhone: {}
 *   primaryContact: if exist
 * } 
 * Also, for 'AddressUsageTypeID',
 *     17 -> BH(businese hour) phone, 18 -> AH(after hour) phone, 19 -> MB(mobile) phone
 * @param {*} transfreeDetails 
 * @param {*} currentState, which determines which CURD process is
 */
function getPhoneNumbers(transfreeDetails, currentState) {
    let returnPhones = {};  // return the object of phones
    const phones = transfreeDetails.RelatedTelephoneNumbers;
    // iterate through phones
    phones.forEach(phone => {
        let singlePhone = getSinglePhone(phone, currentState);

        switch (phone["AddressUsageTypeID"]) {
            case 17:
                returnPhones.BHPhone = singlePhone;
                if (phone.IsPrimaryContact === true)
                    returnPhones.PrimaryContact = 'BHPhone';
                break;
            case 18:
                returnPhones.AHPhone = singlePhone;
                if (phone.IsPrimaryContact === true)
                    returnPhones.PrimaryContact = 'AHPhone';
                break;
            case 19:
                returnPhones.MBPhone = singlePhone;
                if (phone.IsPrimaryContact === true)
                    returnPhones.PrimaryContact = 'MBPhone';
                break;
            default:
                ;
        }
    });

    if (returnPhones.BHPhone === undefined) {
        returnPhones.BHPhone = createSinglePhone(transfreeDetails.PartyID, 17);
    }
    if (returnPhones.AHPhone === undefined) {
        returnPhones.AHPhone = createSinglePhone(transfreeDetails.PartyID, 18);
    }
    if (returnPhones.MBPhone === undefined) {
        returnPhones.MBPhone = createSinglePhone(transfreeDetails.PartyID, 19);
    }

    return returnPhones;
}

// find the preferred contact method. 1 => phone, 2 => email, 3 => mail, 4 => other, default doesn't contain
function getPrefMethod(transfreeDetails) {
    switch (transfreeDetails["PreferredContactMethodTypeID"]) {
        case 1:
            return 'Telephone';
        case 2:
            return 'Email';
        case 3:
            return 'Mail';
        case 4:
            return 'Alternate Contact';
        default:
            return '';
    }
}

// find the primary email address, check if IsPrimaryContact is true
function getPrimaryEmail(transfreeDetails) {
    for (var email of transfreeDetails.RelatedElectronicAddresses) {
        if (email) {
            email.CurrentState = 2;
            return email;
        }
    };
}

function getEmailByAddressUsageTypeID(transfreeDetails, addressUsageTypeID) {
    for (var email of transfreeDetails.RelatedElectronicAddresses) {
        if (email.AddressUsageTypeID === addressUsageTypeID) {
            return email;
        }
    };
}

/**
 * Get all the emails
 * @param {list} transfreeDetails 
 */
function getEmails(transfreeDetails) {
    const emails = transfreeDetails.RelatedElectronicAddresses;
    let emailList = [];
    emails.forEach(email => {
        if (email.IsPrimaryContact === true) {
            email.CurrentState = 2;
        }
        emailList.push(email);
    });
    return emailList;
}

function getFirstName(transfreeDetails) {
    return transfreeDetails.GivenName;
}

function getLastName(transfreeDetails) {
    return transfreeDetails.FamilyName;
}

function getDepartment(transfreeDetails) {
    return transfreeDetails.DepartmentName === null ? '' : transfreeDetails.DepartmentName;
}

function getRank(transfreeDetails) {
    return transfreeDetails.Title === null ? '' : transfreeDetails.Title;
}


function getPosition(transfreeDetails) {
    return transfreeDetails.PositionName === null ? '' : transfreeDetails.PositionName;
}

function getPMKeysNumber(transfreeDetails) {
    return transfreeDetails.EmployeeNumber === null ? '' : transfreeDetails.EmployeeNumber;
}

/**
 * Generate a single address object
 * @param {*} transfreeDetails 
 */
function getSingleAddress(address, currentState) {
    let singleAddress = {};

    singleAddress.AddressID = address.AddressID;
    singleAddress.StreetAddressLine1 = address.StreetAddressLine1 === null ? '' : address.StreetAddressLine1;
    singleAddress.StreetAddressLine2 = address.StreetAddressLine2 === null ? '' : address.StreetAddressLine2;
    singleAddress.StreetAddressState = address.StreetAddressState;
    singleAddress.StreetAddressPostCode = address.StreetAddressPostCode === null ? '' : address.StreetAddressPostCode;
    singleAddress.StreetAddressCity = address.StreetAddressCity;
    singleAddress.AddressTypeID = address.AddressTypeID;
    singleAddress.PartyID = address.PartyID;
    singleAddress.IsPrimaryContact = address.IsPrimaryContact;
    singleAddress.AddressUsageTypeID = address.AddressUsageTypeID;
    singleAddress.AddressSubTypeID = address.AddressSubTypeID;
    singleAddress.ConcurrencyCheck = address.ConcurrencyCheck;
    singleAddress.PartyAddressConcurrencyCheck = address.PartyAddressConcurrencyCheck;
    singleAddress.PartyAddressID = address.PartyAddressID;
    singleAddress.CurrentState = currentState;
    singleAddress.StreetAddressCountry = address.StreetAddressCountry;
    singleAddress.AddressUsageTypeName = address.AddressUsageTypeName;
    singleAddress.Locality = address.Locality;
    singleAddress.PartyAddressPreferredContactMethodTypeID = address.PartyAddressPreferredContactMethodTypeID;
    singleAddress.StreetAddressConcurrencyCheck = address.StreetAddressConcurrencyCheck;
    singleAddress.SectionId = address.SectionId;
    singleAddress.StreetAddressAddressID = address.StreetAddressAddressID;
    singleAddress.IsDeleted = address.IsDeleted;
    singleAddress.IsValidated = address.IsValidated;
    singleAddress.PartyAddressUsageTypeName = address.PartyAddressUsageTypeName;
    singleAddress.AddressUsageTypeName = address.AddressUsageTypeName;
    singleAddress.StreetAddressLongitude = address.StreetAddressLongitude;
    singleAddress.StreetAddressLatitude = address.StreetAddressLatitude;

    return singleAddress;
}

// to generate a dummy address, currently only generate home and postal address
function createSingleAddress(partyId, addressUsageTypeID) {
    let singleAddress = {};
    singleAddress.AddressID = 0;
    singleAddress.PartyID = partyId;
    singleAddress.StreetAddressLine1 = "";
    singleAddress.StreetAddressLine2 = "";
    singleAddress.StreetAddressState = "";
    singleAddress.StreetAddressPostCode = "";
    singleAddress.StreetAddressCity = "";
    singleAddress.Suburb = "";
    singleAddress.StreetAddressCountry = "Australia";
    singleAddress.AddressUsageTypeID = addressUsageTypeID;
    singleAddress.CurrentState = 1;
    singleAddress.AddressUsageTypeName = addressUsageTypeID === 2 ? 'Home' : 'Postal';
    singleAddress.Locality = 0;
    singleAddress.AddressSubTypeID = 0;
    singleAddress.PartyAddressPreferredContactMethodTypeID = 0;
    singleAddress.ConcurrencyCheck = null;
    singleAddress.PartyAddressConcurrencyCheck = null;
    singleAddress.StreetAddressConcurrencyCheck = null;
    singleAddress.PartyAddressID = 0;
    singleAddress.SectionId = 0;
    singleAddress.IsPrimaryContact = addressUsageTypeID === 2 ? true : false;
    singleAddress.StreetAddressAddressID = 0;
    singleAddress.IsDeleted = false;
    singleAddress.IsValidated = true;
    singleAddress.PartyAddressUsageTypeName = null;
    singleAddress.LatitudeAddressLevel = null;
    singleAddress.LongitudeAddressLevel = null;
    singleAddress.LatitudeStreetLevel = null;
    singleAddress.LongitudeStreetLevel = null;
    singleAddress.LatitudeLocalityLevel = null;
    singleAddress.LongitudeLocalityLevel = null;
    singleAddress.StreetAddressLatitude = 0;
    singleAddress.StreetAddressLongitude = 0;
    return singleAddress;
}

// call getAddress to get all the address, then extract work address to return
function getWorkAddress(transfreeDetails, currentState) {
    const allAddress = getAddress(transfreeDetails, currentState);
    return allAddress.Work;
}

// get a list of address, including work, home, and postal
// work and postal seemed only required in contactDetails, but work is required in other as well
function getAddress(transfreeDetails, currentState) {
    const addresses = transfreeDetails.RelatedStreetAddresses;
    let returnAddresses = {};
    if (addresses !== undefined) {
        addresses.forEach(address => {
            const singleAddress = getSingleAddress(address, currentState);
            switch (address["AddressUsageTypeName"]) {
                case 'Home':
                    returnAddresses.Home = singleAddress;
                    break;
                case 'Postal':
                    returnAddresses.Postal = singleAddress;
                    break;
                case 'Work':
                    returnAddresses.Work = singleAddress;
                    break;
                default:
                    break;
            }
        });
    }

    if (returnAddresses.Home === undefined) {
        returnAddresses.Home = createSingleAddress(transfreeDetails.PartyID, 2);
    }
    if (returnAddresses.Postal === undefined) {
        returnAddresses.Postal = createSingleAddress(transfreeDetails.PartyID, 1);
    }

    return returnAddresses;
}

function getFullName(transferee) {
    let { GivenName, FamilyName } = transferee;
    return GivenName + ' ' + FamilyName;
}

export default {
    getSinglePhone, getPhoneNumbers, getPrefMethod, getPrimaryEmail, getWorkAddress,
    getFirstName, getLastName, getDepartment, getRank, getPosition, getPMKeysNumber,
    getAddress, getSingleAddress, getEmails, createSingleAddress, phoneNumberMask,
    unmaskPhoneNumber, getEmailByAddressUsageTypeID, getPhoneNumByAddressUsageTypeID,
    getFullName,
};